/**
 * Return the subject name that has provided subject ids
 * @param {Array} subjects: array containing subject object
 * @param {Array} subjectIds: array of subject ids
 * @returns array of subject names
 *
 *   Example input:
 *
 *       // subjects
 *       [{
 *           'ids':[1, 5],
 *           'name': 'Italiano'
 *        },
 *        {
 *           'ids':[2, 3, 4],
 *           'name': 'Matematica'
 *        }]
 *      //subjectIds
 *          [1, 5]
 *   Example output:
 *
 *       ['Italiano']
 *
 */
export function getSubjectsName(subjects, subjectIds) {
    if (!subjects || !subjectIds || !Array.isArray(subjects) || !Array.isArray(subjectIds)) {
        return [];
    }
    return subjects.filter(subject => subjectIds.find(subjectId => subject.ids.includes(subjectId))).map(subject => subject.name);
}

/**
 * Return the year name that has provided ordinal
 * @param {Array} years: array containing year object
 * @param {String} ordinal: ordinal string
 * @returns string of year name
 *
 *   Example input:
 *
 *       // years
 *       [{
 *           'ordinal':'08',
 *           'name': '2008'
 *        },
 *        {
 *           'ordinal':'09',
 *           'name': '2009'
 *        }]
 *      //yearOrdinal
 *          '08'
 *   Example output:
 *
 *       '2008'
 *
 */
export function getYearName(years, yearOrdinal) {
    if (!years || years.length === 0 || !Array.isArray(years) || !yearOrdinal) {
        return '';
    }
    const year = years.find(year => year.ordinal === yearOrdinal);
    return year ? year.name : '';
}

/**
 * Return the itemTypes name that has provided ids
 * @param {Array} itemTypes: array containing itemTypes object
 * @param {Array} itemTypeIds: array containing itemTypes id
 * @returns array containing string of itemType
 *
 *   Example input:
 *
 *       // itemTypes
 *       [{
 *           'id':124,
 *           'name': 'Completamento chiuso'
 *        },
 *        {
 *           'id':914,
 *           'name': 'TrovaErrore'
 *        }]
 *      //itemTypeIds
 *          [124]
 *   Example output:
 *       ['Completamento chiuso']
 *
 */
export function getItemTypeNames(itemTypes, itemTypeIds) {
    if (!itemTypes || !Array.isArray(itemTypes) || itemTypes.length === 0 || !itemTypeIds || !Array.isArray(itemTypeIds) || itemTypeIds.length === 0) {
        return [];
    }
    return itemTypes.filter(itemType => itemTypeIds.includes(itemType.id)).map(itemType => itemType.name);
}
